
import React, { useState, useEffect } from "react";
import "../Styles/CommitteeMembers.css";

// Import images
import Senthil from "../Assests/senthil.jpeg";
import Santhosh from "../Assests/Santhosh.jpeg";
import Madhu from "../Assests/Madhu.jpeg";
import Sanalg from "../Assests/Sanalg.jpeg";
import Melshanti from "../Assests/Melshanti.jpeg";
import Vishnu from "../Assests/Vishnu.jpeg";
import Ratheesh from "../Assests/Ratheesh.jpeg";
import shylaja from "../Assests/shylaja.jpeg";
import sasi from "../Assests/sasi.jpeg";
import monish from "../Assests/monish.jpeg";
import siju from "../Assests/siju.jpeg";
import eashu1 from "../Assests/eashu1.jpeg";
import Ramalekshmi from "../Assests/Ramalekshmi.jpeg";
import Sankaran from "../Assests/Sankaran.jpeg";
import Rajendar from "../Assests/Rajendar.jpeg";
import Arunmosad from "../Assests/Arunmosad.jpeg";
import Vasu from "../Assests/vasu.jpeg";
import Bharathan from "../Assests/bharathan.jpeg";
import Rakesh from "../Assests/Rakesh.jpeg";
import Anithadevi from "../Assests/Anithadevi.jpeg";
import Narayanan from "../Assests/Narayanan.jpeg";
import Preethi from "../Assests/Preethi.jpeg";

const committeeMembers = [
    { id: 3, name: "Sri. Madhu P.", designation: "Rakshadhikari", image: Madhu },
    { id: 1, name: "Sri. SanalKumar M.C.", designation: "President", image: Sanalg },
    { id: 2, name: "Sri. Saseendran Nair", designation: "VicePresident", image: sasi },
    { id: 4, name: "Sri. SanthoshKumar V.N.", designation: "Secretary", image: Santhosh },
    { id: 5, name: "Sri. SenthilKumar S", designation: "Treasurer", image: Senthil },
    { id: 6, name: "Sri. Ratheesh M.N.", designation: "Joint Treasurer", image: Ratheesh },
    { id: 7, name: "Sri. Bharath M.A.", designation: "Committee Member", image: Bharathan },
    { id: 8, name: "Sri. Monish", designation: "Committee Member", image: monish },
    { id: 9, name: "Sri. Siju", designation: "Committee Member", image: siju },
    { id: 10, name: "Sri. Vishnu", designation: "Committee Member", image: Vishnu },
    { id: 11, name: "Sri.Sankaran", designation: "Committee Member", image: Sankaran },
    { id: 12, name: "Sri.Narayanan", designation: "Committee Member", image: Narayanan },
    { id: 13, name: "Smt. Ramalekshmi S", designation: "Committee Member", image: Ramalekshmi },
    { id: 14, name: "Smt. Parameshwari K", designation: "Committee Member", image: eashu1 },
    { id: 15, name: "Smt. Sailaja S Nair", designation: "Committee Member", image: shylaja },
    { id: 16, name: "Smt. AnithaDevi", designation: "Committee Member", image: Anithadevi },
    { id: 16, name: "Smt. Preethi P.K.", designation: "Committee Member", image: Preethi }
];

// Bottom section members
const bottomSectionMembers = [
    {
        id: 1,
        category: "Temp Than",
        name: "Brahmasri Vezhaparambu Chithrabhanu Namboothiri",
        image: Melshanti
    },
    {
        id: 2,
        category: "Temp Than",
        name: "Brahmasri Vasudevan Namboothiri",
        image: Vasu
    },
    {
        id: 4,
        category: "Guruthi",
        name: "Sri. Arun Moosad",
        image: Arunmosad
    },
    {
        id: 3,
        category: "Guruthi",
        name: "Sri. Rajendran Moosad",
        image: Rajendar
    },
    {
        id: 5,
        category: "Samb",
        name: "Sri. Thrikkapuram Rakesh",
        image: Rakesh
    }
];

function CommitteeMembers() {
    const [isTamil, setIsTamil] = useState(false);

    useEffect(() => {
        const detectLanguage = () => {
            const selectedLanguage =
                document.querySelector(".goog-te-combo")?.value;

            const pageLanguage =
                document.documentElement.lang?.toLowerCase() || "";

            setIsTamil(
                selectedLanguage === "ta" ||
                pageLanguage.startsWith("ta")
            );
        };

        document.addEventListener("change", detectLanguage);

        const observer = new MutationObserver(detectLanguage);

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["lang"]
        });

        detectLanguage();

        return () => {
            document.removeEventListener("change", detectLanguage);
            observer.disconnect();
        };
    }, []);

    // Manually written Tamil translations
    const tamilText = {
        galleryTitle: "புகைப்படத் தொகுப்பு",
        rakshadhikari: "ரக்ஷாதிகாரி",
        president: "தலைவர்",
        vicePresident: "துணைத் தலைவர்",
        secretary: "செயலாளர்",
        treasurer: "பொருளாளர்",
        jointTreasurer: "இணைப் பொருளாளர்",
        committeeMember: "குழு உறுப்பினர்",
        thanthrikal: "க்ஷேத்ரம் தந்திரிகள்",
        guruthi: "சக்தேய குருதி பூஜகர்கள்",
        sambandhi: "க்ஷேத்ரம் சம்பந்தி"
    };

    const getDesignation = (designation) => {
        if (!isTamil) return designation;

        const translations = {
            Rakshadhikari: tamilText.rakshadhikari,
            President: tamilText.president,
            VicePresident: tamilText.vicePresident,
            Secretary: tamilText.secretary,
            Treasurer: tamilText.treasurer,
            "Joint Treasurer": tamilText.jointTreasurer,
            "Committee Member": tamilText.committeeMember
        };

        return translations[designation] || designation;
    };

    // Prevent Google Translate from translating manual Tamil text again
    const manualTamil = (text) => (
        <span className="notranslate" translate="no">
            {text}
        </span>
    );

    return (
        <div className="committee-page">

            {/* Upper Section Header */}
            <div className="committee-header">
                <h1>
                    {isTamil
                        ? manualTamil(tamilText.galleryTitle)
                        : "Photo Gallery"}
                </h1>
            </div>

            {/* Top Committee Members */}
            <div className="committee-container grid-5">
                {committeeMembers.map((member) => (
                    <div className="member-card" key={member.id}>
                        <div className="member-image-container">
                            <img
                                src={member.image}
                                alt={member.name}
                                className="member-image"
                            />
                        </div>

                        <div className="member-details">
                            <h2>{member.name}</h2>
                            <p>
                                {isTamil
                                    ? manualTamil(
                                        getDesignation(member.designation)
                                    )
                                    : member.designation}
                            </p>
                        </div>
                    </div>
                ))}
            </div>

            {/* Bottom Section Headers */}
            <div className="bottom-section-container">
                <div className="bottom-headers-grid">

                    <h2 className="header-span-2">
                        {isTamil
                            ? manualTamil(tamilText.thanthrikal)
                            : "Kshethram Thanthrikal"}
                    </h2>

                    <h2 className="header-span-2">
                        {isTamil
                            ? manualTamil(tamilText.guruthi)
                            : "Saktheya Guruthi Poojakar"}
                    </h2>

                    <h2 className="header-span-1">
                        {isTamil
                            ? manualTamil(tamilText.sambandhi)
                            : "Kshethram Sambandhi"}
                    </h2>

                </div>

                {/* Bottom Members */}
                <div className="committee-container grid-5">
                    {bottomSectionMembers.map((member) => (
                        <div className="member-card" key={member.id}>
                            <div className="member-image-container">
                                <img
                                    src={member.image}
                                    alt={member.name}
                                    className="member-image"
                                />
                            </div>

                            <div className="member-details">
                                <h2>{member.name}</h2>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default CommitteeMembers;
